import React, {Component} from "react";
import PropTypes from "prop-types";
import Modal from "../Modal";
import Tee from "./Tee";
import SummerDress from "./SummerDress";
import Skirt from "./Skirt";
import PleatedSkirt from "./PleatedSkirt";
import PencilSkirt from "./PencilSkirt";
import LongSleeveDress from "./LongSleeveDress";
import Leggings from "./Leggings";
import FullPrintWomanTanktop from "./FullPrintWomanTanktop";
import FullPrintTanktop from "./FullPrintTanktop";
import Bomber from "./Bomber";

import styles from "./size-info.module.scss";

export default class SizeInfo extends Component {
  static propTypes = {
    name: PropTypes.string
  };
  state = {
    isOpen: false
  };
  openModal = () => {
    this.setState({
      isOpen: true
    });
  };
  closeModal = () => {
    this.setState({
      isOpen: false
    });
  };
  getSizeInfoByName(name) {
    switch (name) {
      case `tee`:
        return <Tee />;
      case `summer_dress`:
        return <SummerDress />;
      case `skirt`:
        return <Skirt />;
      case `pleated_skirt`:
        return <PleatedSkirt />;
      case `pencil_skirt`:
        return <PencilSkirt />;
      case `long_sleeve_dress`:
        return <LongSleeveDress />;
      case `leggings`:
        return <Leggings />;
      case `full_print_woman_tanktop`:
        return <FullPrintWomanTanktop />;
      case `full_print_tanktop`:
        return <FullPrintTanktop />;
      case `bomber`:
        return <Bomber />;

      default:
        return <Tee />;
    }
  }
  render() {
    const {name} = this.props;
    return (
      <div className={styles.root}>
        <button className={styles.button} onClick={this.openModal}>
          Как выбрать правильный размер?
        </button>
        <Modal isOpen={this.state.isOpen} onRequestClose={this.closeModal}>
          {this.getSizeInfoByName(name)}
        </Modal>
      </div>
    );
  }
}
